import type { PluginWebManifest } from '@reflex/plugin-api/web';

export const impersonationWeb: PluginWebManifest = {
  commands: [
    {
      label: 'Impersonate user…',
      to: '#impersonation:start',
      icon: 'UserCog',
      group: 'admin',
    },
  ],
  adminUserActions: [
    {
      id: 'impersonate',
      componentPath: '@reflex/plugin-impersonation/web/AdminUserImpersonateAction',
      order: 100,
    },
  ],
  globalUiElements: [
    {
      id: 'impersonation-banner',
      componentPath: '@reflex/plugin-impersonation/web/ImpersonationBanner',
    },
    {
      id: 'impersonation-dialog',
      componentPath: '@reflex/plugin-impersonation/web/StartImpersonationDialog',
    },
  ],
};
